import { wagmiConfig } from "@shared/src/config/wagmiConfig";
import { Connector } from "wagmi";

export type WalletType = "social" | "wallet";

export interface SocialWalletConfig {
  id: string;
  name: string;
  logoUrl: string;
  type: WalletType;
  category: "popular" | "all";
}

export const SOCIAL_WALLET_CONFIG: SocialWalletConfig[] = [
  {
    id: "google",
    name: "Google",
    logoUrl: "/images/logos/GoogleLogo.png",
    type: "social",
    category: "popular",
  },
  {
    id: "facebook",
    name: "Facebook",
    logoUrl: "/images/logos/FacebookLogo.png",
    type: "social",
    category: "popular",
  },

  // All Wallets (using MetaMask logo as placeholder for now)
];

// Helper functions
export const getPopularWallets: () => readonly Connector[] = () => wagmiConfig.connectors;

export const getSocialLogins = () => SOCIAL_WALLET_CONFIG;

export const getAllWallets = () => SOCIAL_WALLET_CONFIG;
